import type { SVGProps } from "react"

const PhotoAndUnderwriting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <defs>
      <clipPath id="prefix__a">
        <path data-name="Rectangle 1586" fill="none" d="M0 0h350v350H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 4058" clipPath="url(#prefix__a)">
      <path
        data-name="Path 41482"
        d="M175 109.5a65.5 65.5 0 1065.5 65.5 65.574 65.574 0 00-65.5-65.5m0 129.5a64 64 0 1164-64 64.073 64.073 0 01-64 64"
        fill="#98a300"
      />
      <path
        data-name="Path 41483"
        d="M136.382 159.5h3.123a2.885 2.885 0 002.882-2.882v-14.231h14.231a2.885 2.885 0 002.882-2.881v-3.124a2.885 2.885 0 00-2.882-2.882h-20.236a2.885 2.885 0 00-2.882 2.882v20.236a2.885 2.885 0 002.882 2.882M135 136.382a1.384 1.384 0 011.382-1.382h20.236a1.384 1.384 0 011.382 1.382v3.124a1.383 1.383 0 01-1.382 1.381h-15.731v15.731a1.384 1.384 0 01-1.382 1.382h-3.123a1.384 1.384 0 01-1.382-1.382z"
        fill="#98a300"
      />
      <path
        data-name="Path 41484"
        d="M213.618 133.5h-20.236a2.885 2.885 0 00-2.882 2.882v3.123a2.885 2.885 0 002.882 2.882h14.231v14.231a2.885 2.885 0 002.882 2.882h3.123a2.885 2.885 0 002.882-2.882v-20.236a2.885 2.885 0 00-2.882-2.882M215 156.618a1.384 1.384 0 01-1.382 1.382h-3.123a1.384 1.384 0 01-1.382-1.382v-15.731h-15.731a1.384 1.384 0 01-1.382-1.382v-3.123a1.384 1.384 0 011.382-1.382h20.236a1.384 1.384 0 011.382 1.382z"
        fill="#98a300"
      />
      <path
        data-name="Path 41485"
        d="M213.618 190.5h-3.123a2.885 2.885 0 00-2.882 2.882v14.23h-14.231a2.886 2.886 0 00-2.882 2.883v3.122a2.886 2.886 0 002.882 2.883h20.236a2.886 2.886 0 002.882-2.883v-20.235a2.885 2.885 0 00-2.882-2.882M215 213.617a1.384 1.384 0 01-1.382 1.383h-20.236a1.384 1.384 0 01-1.382-1.383v-3.122a1.384 1.384 0 011.382-1.383h15.731v-15.73a1.384 1.384 0 011.382-1.382h3.123a1.384 1.384 0 011.382 1.382z"
        fill="#98a300"
      />
      <path
        data-name="Path 41486"
        d="M156.618 207.612h-14.231v-14.23a2.885 2.885 0 00-2.882-2.882h-3.123a2.885 2.885 0 00-2.882 2.882v20.235a2.886 2.886 0 002.882 2.883h20.236a2.886 2.886 0 002.882-2.883v-3.122a2.886 2.886 0 00-2.882-2.883m1.382 6.005a1.384 1.384 0 01-1.382 1.383h-20.236a1.384 1.384 0 01-1.382-1.383v-20.235a1.384 1.384 0 011.382-1.382h3.123a1.384 1.384 0 011.382 1.382v15.73h15.731a1.384 1.384 0 011.382 1.383z"
        fill="#98a300"
      />
      <path
        data-name="Path 41487"
        d="M197.846 184.307h3.2a4.458 4.458 0 004.458-4.458v-7.061a4.458 4.458 0 00-4.458-4.457h-9.375l-4.925-8.255a3.23 3.23 0 00-2.775-1.576h-17.938a3.233 3.233 0 00-2.776 1.576l-4.924 8.255h-9.375a4.457 4.457 0 00-4.458 4.457v7.061a4.458 4.458 0 004.458 4.458h3.2a7.015 7.015 0 0013.922 0h17.848a7.015 7.015 0 0013.922 0"
        fill="#f2f5cc"
      />
    </g>
  </svg>
)
export { PhotoAndUnderwriting }
